import { createFileRoute } from "@tanstack/react-router";

import ColorsPage from "@/app/design-system/colors/ColorsPage";

export const Route = createFileRoute("/admin/design-system/colors")({
  component: ColorsPage,
});
